import * as visaicon from "~/assets/images/icons/Visa_lztyeu.png"; //1
import * as mastercard from "~/assets/images/icons/master_card.png"; //2
import * as successIcon from "~/assets/images/icons/icons-success.png"; //3
import * as failureIcon from "~/assets/images/icons/icons-fail.png"; //4

export {
    mastercard, visaicon, successIcon, failureIcon
}